import * as CopyToClipboard from "react-copy-to-clipboard"
import * as React from "react"

import { Action, ActionType } from "@tenforce/toolbox-button-push-react"
import { Modal } from "@tenforce/toolbox-modal-react"

import { Symbols } from "@tenforce/toolbox-fontmap"

interface Props {
    buttonId: string
    numberText?: string
    showCaption: boolean
    successMessage: string
    resourceTitle: string
    tooltip: string
    url: string
    extraClasses?: string
}

interface State {
    showSuccessMessage: boolean
}

const autoDisappearDelay = 2000

export default class ShareButton extends React.PureComponent<Props, State> {
    constructor(props: Props) {
        super(props)

        this.state = {
            showSuccessMessage: false,
        }
    }

    render(): JSX.Element {
        const {
            buttonId,
            numberText,
            successMessage,
            showCaption,
            resourceTitle,
            tooltip,
            url,
            extraClasses,
        } = this.props
        const { showSuccessMessage } = this.state

        const content = (
            <>
                {Symbols.CopyToClipboard}
                {showCaption && <>&nbsp;</>}
                {showCaption && tooltip}
            </>
        )

        const text = numberText
            ? `${numberText} - ${resourceTitle} - ${url}`
            : `${resourceTitle} - ${url}`

        return (
            <>
                <CopyToClipboard
                    text={text}
                    onCopy={(): void => {
                        this.setSuccessMessageVisibility(true)
                        setTimeout(() => {
                            this.setSuccessMessageVisibility(false)
                        }, autoDisappearDelay)
                    }}
                    options={{ format: "text/plain" }}
                >
                    <Action
                        title={tooltip}
                        id={buttonId}
                        data-ft-title={resourceTitle}
                        data-ft-url={url}
                        actionType={ActionType.icon}
                        extraClasses={extraClasses}
                    >
                        {content}
                    </Action>
                </CopyToClipboard>

                <Modal
                    isShown={showSuccessMessage}
                    containerProps={{
                        id: "shareSuccessMessageModal",
                        targetSelector: `#${buttonId}`,
                        onClose: (): void => {
                            this.setSuccessMessageVisibility(false)
                        },
                    }}
                >
                    <div className="theme-bubble theme-settings animate-movebgstripes tw-w-fit tw-px-3 tw-py-1">
                        <p>{successMessage}</p>
                    </div>
                </Modal>
            </>
        )
    }

    setSuccessMessageVisibility = (visibility: boolean): void => {
        this.setState({
            showSuccessMessage: visibility,
        })
    }
}
